// extracted by mini-css-extract-plugin
module.exports = {"summaryError":"CalculatorResult_summaryError__X22ff","summaryText":"CalculatorResult_summaryText__R2J4k"};